export const eur = (v) =>
  new Intl.NumberFormat("fr-FR", { style: "currency", currency: "EUR", maximumFractionDigits: 0 }).format(v || 0);

export const eur2 = (v) =>
  new Intl.NumberFormat("fr-FR", { style: "currency", currency: "EUR" }).format(v || 0);

export const km = (v) => `${new Intl.NumberFormat("fr-FR").format(v || 0)} km`;

export const fdate = (d) => {
  if (!d) return "—";
  try {
    return new Date(d).toLocaleDateString("fr-FR", { day: "2-digit", month: "2-digit", year: "numeric" });
  } catch {
    return d;
  }
};

export const fdatetime = (d) => {
  if (!d) return "—";
  try {
    return new Date(d).toLocaleString("fr-FR", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" });
  } catch {
    return d;
  }
};

export const STATUS_META = {
  disponible: { label: "Disponible", cls: "bg-emerald-50 text-emerald-800 border-emerald-200" },
  affecte: { label: "Affecté", cls: "bg-[#EEF2F8] text-[#001A3B] border-[#C7D5EC]" },
  maintenance: { label: "Maintenance", cls: "bg-amber-50 text-amber-800 border-amber-200" },
  immobilise: { label: "Immobilisé", cls: "bg-red-50 text-red-800 border-red-200" },
  commande: { label: "En commande", cls: "bg-[#F4EFE3] text-[#7a6323] border-[#e3d5ab]" },
  restitue: { label: "Restitué", cls: "bg-gray-100 text-gray-700 border-gray-300" },
};

export const URGENCY = {
  critical: { label: "Urgent", cls: "bg-red-50 text-red-800 border-red-200", dot: "#DC2626" },
  warning: { label: "Bientôt", cls: "bg-amber-50 text-amber-800 border-amber-200", dot: "#EA580C" },
  ok: { label: "À jour", cls: "bg-emerald-50 text-emerald-800 border-emerald-200", dot: "#059669" },
  neutral: { label: "—", cls: "bg-gray-100 text-gray-600 border-gray-300", dot: "#6B7280" },
};

export const ROLE_LABELS = {
  admin: "Administrateur",
  fleet_manager: "Gestionnaire de flotte",
  hr: "Ressources Humaines",
  finance: "Finance",
  driver: "Conducteur",
};

export const ENERGY_META = {
  Diesel: "text-slate-700",
  Essence: "text-orange-700",
  Hybride: "text-teal-700",
  Electrique: "text-emerald-700",
};

export const CV_STATUS_META = {
  nouvelle: { label: "Nouvelle", cls: "bg-sky-50 text-sky-800 border-sky-200", dot: "#0284C7" },
  a_traiter: { label: "À traiter", cls: "bg-amber-50 text-amber-800 border-amber-200", dot: "#D97706" },
  conducteur_a_designer: { label: "Conducteur à désigner", cls: "bg-orange-50 text-orange-800 border-orange-200", dot: "#EA580C" },
  conducteur_designe: { label: "Conducteur désigné", cls: "bg-indigo-50 text-indigo-800 border-indigo-200", dot: "#4F46E5" },
  en_attente_paiement: { label: "En attente de paiement", cls: "bg-yellow-50 text-yellow-800 border-yellow-200", dot: "#CA8A04" },
  payee: { label: "Payée", cls: "bg-emerald-50 text-emerald-800 border-emerald-200", dot: "#059669" },
  contestee: { label: "Contestée", cls: "bg-purple-50 text-purple-800 border-purple-200", dot: "#9333EA" },
  annulee: { label: "Annulée", cls: "bg-gray-100 text-gray-700 border-gray-300", dot: "#6B7280" },
  cloturee: { label: "Clôturée", cls: "bg-slate-100 text-slate-700 border-slate-300", dot: "#475569" },
};

export const CvStatus = (status) => CV_STATUS_META[status] || CV_STATUS_META.nouvelle;

export const daysUntil = (d) => (d ? Math.ceil((new Date(d) - new Date()) / 86400000) : null);

export const monthsBetween = (a, b = new Date()) => {
  if (!a) return null;
  const s = new Date(a), e = new Date(b);
  if (isNaN(s) || isNaN(e)) return null;
  let m = (e.getFullYear() - s.getFullYear()) * 12 + (e.getMonth() - s.getMonth());
  if (e.getDate() < s.getDate()) m -= 1;
  return m;
};

export const fmonths = (m) => {
  if (m == null || m < 0) return "—";
  const y = Math.floor(m / 12), r = m % 12;
  const parts = [];
  if (y) parts.push(`${y} an${y > 1 ? "s" : ""}`);
  if (r || !y) parts.push(`${r} mois`);
  return parts.join(" ");
};

export const RENEWAL_META = {
  ok: { label: "Conforme", cls: "bg-emerald-50 text-emerald-800 border-emerald-200" },
  bientot: { label: "À renouveler bientôt", cls: "bg-amber-50 text-amber-800 border-amber-200" },
  prolongation: { label: "En prolongation", cls: "bg-sky-50 text-sky-800 border-sky-200" },
  depasse: { label: "Dépassé", cls: "bg-red-50 text-red-800 border-red-200" },
};

// 4-year renewal rule: warning 3 months before, +1 year if extension granted, overdue beyond.
export const renewalStatus = (v) => {
  const m = monthsBetween(v?.purchase_date);
  if (m == null || v.status === "restitue") return null;
  if (m >= 60) return "depasse";
  if (m >= 48) return v.extension_granted ? "prolongation" : "depasse";
  if (m >= 45) return "bientot";
  return "ok";
};

